import { useAssetParentFragment } from '../gql/generated/AssetParent';

/**
 * Returns the id of an asset's parent FolderAsset, while taking
 * version stacks into account.
 *
 * @param id The id of the asset
 * @returns id The id of the parent folder asset, or undefined if not cached
 */
export function useAssetParentFolderId(id: string) {
  const { data: asset } = useAssetParentFragment({
    from: {
      __typename: 'Asset',
      id,
    },
  });

  if (!asset?.parent) return undefined;

  return asset.parent.__typename === 'VersionStackAsset'
    ? asset.parent.parent?.id
    : asset.parent.id;
}
